<template>
  <div>
    <v-card tile flat>
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5 primary white--text">
            <v-container>
              <h1 class="headline">
                Jadwal
                {{ $getDeepObj(configs, 'title') }}
                ( {{ $durasi($getDeepObj(configs, 'tgl_mulai'), this.$getDeepObj(configs, 'tgl_selesai')) }} )
              </h1>
              <p>
                Silakan memilih Tanggal dan Sesi Anda pada Form di bawah ini, fungsi dari set jadwal adalah Agar sistem
                kami bisa memilihkan kandidat yang akan anda Nilai.
              </p>
              <v-divider class="my-4" dark style="border-top: 1px solid #42a5f5" />
              <h2 class="font-weight-regular mb-4"> Jadwal Sesi Ujian /per hari yang disediakan</h2>
              <v-row dense>
                <v-col cols="12" md="8" sm="12">
                  <v-row dense>
                    <v-col cols="12" md="6" sm="12">
                      <span
                        v-for="slot in $getDeepObj(configs, 'slot').slice(
                          0,
                          Math.floor(totalSlot / 2) + (totalSlot % 2 === 0 ? 0 : 1)
                        )"
                        :key="slot.value"
                      >
                        <span v-html="`<b>Slot ${slot.value} : </b> ${slot.text} <br/>`" />
                      </span>
                    </v-col>
                    <v-col cols="12" md="6" sm="12">
                      <span
                        v-for="slot in $getDeepObj(configs, 'slot').slice(Math.round(totalSlot / 2), totalSlot)"
                        :key="slot.value"
                      >
                        <span v-html="`<b>Slot ${slot.value} : </b> ${slot.text} <br/>`" />
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <v-img :src="$imgUrl('timezone.jpg')" max-width="400" max-height="300" />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-if="$allow(`psp-${akses}-simulasi-ajar.update-link`)" class="my-2" elevation="1">
      <v-card-text>
        <v-row no-gutters dense>
          <v-col cols="12" md="4" sm="12" class="d-inline-flex align-center justify-center">
            <v-icon size="120" color="success">mdi-google-hangouts</v-icon>
          </v-col>
          <v-col cols="12" md="8" sm="12">
            <h2 class="black--text">Ruang Simulasi(Gmeet)</h2>
            <p class="mt-1"
              >Fitur ini berfungsi untuk mengganti Tautan Gmeet Room anda yang mengalami kendala. Pastikan Anda login
              dengan akun Gsuite dan membuat Room Gmeet di
              <a href="https://meet.google.com/" target="_blank">https://meet.google.com/ </a> dan salin alamat Room
              Gmeet Anda yang baru pada kolom di bawah ini. Anda dapat cek panduan
              <a class="font-weight-bold" @click="onGmeet">Disini</a>
            </p>

            <v-text-field
              v-model="urlMeet"
              placeholder="Tempelkan url/link gmeet disini..."
              dense
              outlined
              :disabled="!useLink"
            >
            </v-text-field>
            <v-btn :color="useLink ? 'success' : 'primary'" :outlined="!useLink" @click="onSimpanLink">{{
              useLink ? 'Simpan Link' : 'Ubah Link'
            }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mx-0 pa-2 my-5" elevation="1">
      <v-toolbar flat>
        <h3 class="font-weight-medium">
          <template v-if="configs.is_asesor_bantu">
            Anda Asesor B, Anda cukup melihat hasil jadwal yang sudah diatur asesor A
          </template>
          <template v-else> Atur Jadwal Ketersediaan Anda Melakukan Penilaian Kandidat </template>
          <b>
            (
            <span :class="`${totalSesi > configs.max || 0 ? 'red' : 'blue'}--text`">{{ totalSesi }}</span>
            dari <span class="blue--text">{{ total }}</span> )
          </b>
        </h3>
      </v-toolbar>
      <v-divider />
      <v-card-text class="pa-0">
        <v-container>
          <v-alert
            icon="mdi-information"
            close-text="Tutup"
            colored-border
            border="left"
            type="info"
            class="bg-notif"
            color="yellow darken-2"
          >
            <p
              >Sistem akan <b>otomatis mencocokan jadwal Anda dengan jadwal Kandidat yang akan dites,</b> kemudian
              secara otomatis sistem akan mendistribusikan secara acak.</p
            >
            <p>
              Semua Slot / Sesi dalam waktu <b>WIB</b>, Apabila anda di walayah <b>WIT dan WITA</b> mohon untuk
              menyesuaikan waktu zona masing masing.</p
            >
            <p
              ><a
                href="https://id.wikipedia.org/wiki/Zona_waktu_Indonesia#:~:text=Indonesia%20terbagi%20atas%20tiga%20zona%20waktu%20yaitu%3A&text=Waktu%20Indonesia%20Tengah%20atau%20WITA,UTC%2B09%3A00)"
                target="_blank"
                >* cek tautan
                <span class="font-weight-bold">Wikipedia</span>
                untuk detil pembagian Zona waktu di Indonesia
              </a></p
            >
          </v-alert>

          <v-progress-linear
            :color="`${progress < 50 ? 'red' : progress === 100 ? 'success' : 'blue'}`"
            :value="progress"
            height="25"
            dark
          >
            <strong>{{ Math.ceil(progress) }}%</strong>
          </v-progress-linear>

          <div class="my-5">
            <v-row v-for="(sesi, s) in sessions" :key="s" dense>
              <v-col cols="12" :md="isPreview ? 6 : 5" sm="10" class="my-auto">
                <span class="caption">Atur Tanggal *</span>
                <v-select
                  v-model="sessions[s]['tgl_wawancara']"
                  :items="dateAvailable"
                  :disabled="isPreview ? true : !useReguler"
                  label="Atur Tanggal"
                  single-line
                  outlined
                />
              </v-col>
              <v-col cols="12" :md="isPreview ? 6 : 5" sm="10">
                <span class="caption">Atur Sesi / Slot *</span>
                <v-select
                  v-model="sessions[s]['sesi_wawancara']"
                  :items="sessionAvailable(s)"
                  :disabled="isPreview ? true : !useReguler"
                  multiple
                  label="Atur Sesi / Slot"
                  single-line
                  outlined
                  chips
                >
                  <template v-slot:selection="{ item }">
                    <v-chip>
                      <span>Slot {{ item.value }}</span>
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col v-if="!isPreview && useReguler" cols="12" md="2" sm="2" class="my-auto">
                <template v-if="sesi.useDelete">
                  <v-btn block color="red" class="mt-n1" @click="hapusSesi(s, 'sessions')" dark>Hapus</v-btn>
                </template>
                <template v-else>
                  <v-btn block color="primary" class="mt-n1" @click="tambahSesi(s, 'sessions')">Terapkan</v-btn>
                </template>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card v-if="false" class="mx-0 pa-2 my-5" elevation="1">
      <v-toolbar flat>
        <v-toolbar-title class="font-weight-medium"> Atur Jadwal Susulan </v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text class="pa-0">
        <v-container>
          <div class="my-5">
            <v-row v-for="(sesi, s) in extras" :key="s" dense>
              <v-col cols="12" :md="isPreview ? 6 : 5" sm="10" class="my-auto">
                <span class="caption">Atur Tanggal *</span>
                <v-select
                  v-model="extras[s]['tgl_wawancara']"
                  :items="dateExtraAvailable"
                  :disabled="isPreview || blokirTgl(s)"
                  label="Atur Tanggal"
                  single-line
                  outlined
                />
              </v-col>
              <v-col cols="12" :md="isPreview ? 6 : 5" sm="10">
                <span class="caption">Atur Sesi / Slot *</span>
                <v-select
                  v-model="extras[s]['sesi_wawancara']"
                  :items="sessionAvailable(s)"
                  :disabled="isPreview || blokirTgl(s)"
                  multiple
                  label="Atur Sesi / Slot"
                  single-line
                  outlined
                  chips
                >
                  <template v-slot:selection="{ item }">
                    <v-chip>
                      <span>Slot {{ item.value }}</span>
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col v-if="!isPreview" cols="12" md="2" sm="2" class="my-auto">
                <template v-if="sesi.useDelete">
                  <v-btn :disabled="blokirTgl(s)" block color="red" class="mt-n1" @click="hapusSesi(s, 'extras')"
                    >Hapus</v-btn
                  >
                </template>
                <template v-else>
                  <v-btn block color="primary" class="mt-n1" @click="tambahSesi(s, 'extras')">Terapkan</v-btn>
                </template>
              </v-col>
            </v-row>
          </div>
          <div v-if="configs && configs.catatan" class="red--text">
            {{ configs.catatan }}
          </div>
        </v-container>
      </v-card-text>
    </v-card>
    <notifikasi ref="notifikasi" title="Generate Link Gmeet" />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import Notifikasi from '@components/popup/Notifikasi';

export default {
  props: {
    type: {
      type: String,
      default: 'mentor',
    },
    id: {
      type: [String, Number],
      default: '',
    },
    initValue: {
      type: [Object, Array],
      default: () => null,
    },
    configs: {
      type: Object,
      default: () => {},
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    useReguler: {
      type: Boolean,
      default: true,
    },
    useSusulan: {
      type: Boolean,
      default: false,
    },
    blockSlots: {
      type: Array,
      default: () => [],
    },
    akses: {
      type: String,
      default: 'peserta',
    },
  },
  components: { Notifikasi },
  computed: {
    ...mapState('preferensi', {
      gSuite: (state) => (state && state.gSuite) || {},
      akun: (state) => Object.assign({}, state.data.akun),
    }),

    total() {
      return this.configs?.min ?? 0;
    },

    schema() {
      const guru = [
        {
          type: 'VSelect',
          name: 'tgl_wawancara',
          label: 'Atur Tanggal',
          labelColor: 'grey',
          hint: 'wajib diisi',
          items: this.dateAvailable,
          grid: { cols: 12, md: 4 },
          required: true,
          outlined: true,
          dense: true,
        },
        {
          type: 'VSelect',
          name: 'wkt_sesi',
          label: 'Atur Sesi / Slot',
          labelColor: 'grey',
          hint: 'wajib diisi',
          items: this.sessionAvailable,
          grid: { cols: 12, md: 4 },
          required: true,
          outlined: true,
          dense: true,
        },
      ];

      const pendukung = [
        {
          type: 'VDatePicker',
          name: 'tgl_wawancara',
          label: 'Tanggal Wawancara',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 4 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
          min: new Date().toISOString().substr(0, 10),
        },
        {
          type: 'VTimePicker',
          name: 'jam_mulai',
          label: 'Waktu Mulai',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 4 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VTimePicker',
          name: 'jam_selesai',
          label: 'Waktu Selesai',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 4 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
      ];

      return this.type === 'guru' ? guru : pendukung;
    },

    dateAvailable() {
      let temp = [];

      const start = new Date(this.$getDeepObj(this, 'configs.tgl_mulai'));
      const finish = new Date(this.$getDeepObj(this, 'configs.tgl_selesai'));

      for (let d = start; d <= finish; d.setDate(d.getDate() + 1)) {
        let allBlokir = false;
        if (this.$getDeepObj(this.configs.blokir_slot, this.$dateToString(new Date(d)).split(' ')[0])) {
          const jSlot = this.$getDeepObj(this.configs.blokir_slot, this.$dateToString(new Date(d)).split(' ')[0]) || [];
          const jConf = this.$getDeepObj(this.configs, 'slot') || [];
          if (jSlot.length === jConf.length) allBlokir = true;
        }

        temp.push({
          text: this.$localDate(this.$dateToString(new Date(d))),
          value: this.$dateToString(new Date(d)).split(' ')[0],
          disabled:
            this.sessions.find((s) => s.tgl_wawancara === this.$dateToString(new Date(d)).split(' ')[0]) || allBlokir,
        });
      }

      return temp;
    },

    dateExtraAvailable() {
      let extra = this.$getDeepObj(this, 'configs.slot_susulan') || [];
      let temp = [];

      extra.forEach((key) => {
        temp.push({
          text: this.$localDate(key),
          value: key,
          disabled: this.extras.find((s) => s.tgl_wawancara === key) || new Date(key).getDate() === 13,
        });
      });

      return temp;
    },

    isJadwal() {
      return !!Object.keys(this.jadwal).length;
    },

    totalSesi() {
      let nilai = 0;
      this.sessions.forEach((key) => {
        if (key.useDelete === true) {
          nilai += key.sesi_wawancara.length;
        }
      });
      return nilai;
    },

    slotExtra() {
      return this.$getDeepObj(this, 'configs.slot_susulan') || [];
    },

    progress() {
      let nilai = this.totalSesi;
      let total = this.configs?.min ?? 0;
      let precentage = (nilai / total) * 100;

      return precentage >= 100 ? 100 : precentage || 0;
    },

    totalSlot() {
      return this.configs?.slot?.length ?? 0;
    },
  },
  data() {
    return {
      form: {},
      jadwal: null,
      isEdit: false,
      sessions: [],
      extras: [],
      useLink: false,
      urlMeet: '',
    };
  },
  methods: {
    ...mapActions('preferensi', ['getPreferensi']),
    ...mapActions('microteaching', ['setGmeet']),

    reset() {
      this.$set(this, 'form', {});
      this.$set(this, 'jadwal', {});
      this.$set(this, 'isEdit', false);
      this.$set(this, 'useLink', false);
      this.$set(this, 'sessions', []);
      this.$set(this, 'extras', []);
    },

    setJadwal(jadwal) {
      this.jadwal = Object.assign({}, jadwal);
      this.$set(this.form, 'link', this.$getDeepObj(jadwal, 'url'));
      this.$set(this.form, 'gpm_wawancara_kelas_id', this.$getDeepObj(jadwal, 'gpm_wawancara_kelas_id'));
    },

    onJadwal() {
      this.$emit('generate', {
        form: this.form,
        id: this.id,
      });
    },

    getValue() {
      const pendukung = Object.assign(
        {},
        {
          form: this.form,
          wawancara_id: this.$getDeepObj(this.jadwal, 'gpm_wawancara_kelas_id'),
          isEdit: this.isEdit,
        }
      );

      const guru = Object.assign({}, { form: this.sessions, total: this.totalSesi, extras: this.extras });

      return this.type === 'guru' ? guru : pendukung;
    },

    resetJadwal() {
      this.$emit('reset', { id: this.$getDeepObj(this.jadwal, 'gpm_wawancara_kelas_id') });
    },

    initForm(value) {
      if (this.type === 'guru') {
        let obj = value || [];
        if (obj.length) {
          obj.forEach((key) => {
            if (this.slotExtra.includes(key.tgl_wawancara)) {
              this.extras.push({ tgl_wawancara: key.tgl_wawancara, sesi_wawancara: key.sesi, useDelete: true });
            } else {
              this.sessions.push({ tgl_wawancara: key.tgl_wawancara, sesi_wawancara: key.sesi, useDelete: true });
            }
          });

          if (!this.isPreview) {
            this.sessions.push({ tgl_wawancara: '', sesi_wawancara: [], useDelete: false });
          }

          // if (this.extras.length < this.slotExtra.length && !this.isPreview) {
          //   this.extras.push({ tgl_wawancara: '', sesi_wawancara: [], useDelete: false })
          // }
        } else {
          this.sessions.push({ tgl_wawancara: '', sesi_wawancara: [], useDelete: false });
          this.extras.push({ tgl_wawancara: '', sesi_wawancara: [], useDelete: false });
        }

        this.urlMeet = this.$getDeepObj(this.configs, 'url_meet') || '';
      } else {
        const wawancara = this.$getDeepObj(value, 'gpm_wawancara');
        if (Object.keys(wawancara).length) {
          this.isEdit = true;
          for (const key in wawancara) {
            this.$set(this.form, key, wawancara[key]);
            if (key === 'tgl_wawancara') {
              this.$set(this.form, key, wawancara[key].split(' ')[0]);
            }

            if (['jam_mulai', 'jam_selesai'].includes(key)) {
              let nilai = wawancara[key].split(':');
              nilai.pop();
              this.$set(this.form, key, nilai.join(':'));
            }
          }
        }
      }
    },

    sessionAvailable(s) {
      const day = new Date(this.$getDeepObj(this, `sessions.${s}.tgl_wawancara`));
      const date = this.$getDeepObj(this, `sessions.${s}.tgl_wawancara`);
      let temp = [];
      const wktSesi = this.$getDeepObj(this, 'configs.slot') || [];
      const configBlokir = this.$getDeepObj(this, 'configs.blokir_slot') || {};

      wktSesi.forEach((key) => {
        const isJumat = Number(day.getDay()) === 5 ? [...this.blockSlots].includes(Number(key.value)) : false;
        const findBlokir = this.$getDeepObj(configBlokir, date || '') || [];
        const isBlokir = findBlokir.includes(Number(key.value));

        temp.push({
          text: `Slot ke ${key.value} ${key.text}`,
          value: key.value,
          disabled: isJumat || isBlokir,
        });
      });

      return temp;
    },

    tambahSesi(s, key = 'sessions') {
      if (!this[key][s]['tgl_wawancara'] || !this[key][s]['sesi_wawancara']) {
        this.$error(`Harap pilih tanggal dan sesi ${this.$getDeepObj(this, 'configs.title').toLowerCase()}`);
        return;
      }

      this[key][s]['useDelete'] = true;
      this[key].push({ tgl_wawancara: '', sesi_wawancara: '', useDelete: false });
    },

    hapusSesi(s, key = 'sessions') {
      this.$confirm(
        `Anda yakin ingin menghapus sesi berikut ?`,
        `Hapus Sesi ${this.$getDeepObj(this, 'configs.title')} `,
        {
          tipe: 'error',
          data: '',
        }
      ).then(() => {
        if (this[key].length === 1 || key === 'extras') {
          this.$set(this[key], s, { tgl_wawancara: '', sesi_wawancara: [], useDelete: false });
        } else {
          this.$delete(this[key], s);
          const index = this[key].length - 1;
          this[key][index]['useDelete'] = false;
        }
      });
    },

    blokirTgl(s) {
      const date = new Date(this.$getDeepObj(this, `extras.${s}.tgl_wawancara`)).getDate();
      const blokir = [13];
      return blokir.includes(date);
    },

    onSimpanLink() {
      if (this.useLink) {
        this.setGmeet({
          id: this.$getDeepObj(this, 'akun.akun_id'),
          params: { url: this.urlMeet },
          api: this.akses,
        }).then(() => {
          this.$emit('konfig');
          this.useLink = false;
          this.$success('Tautan Ruang Simulasi Berhasil di ubah');
        });
      } else {
        this.useLink = true;
      }
    },

    onGmeet() {
      const html = `
        <div class="black--text">
            <h3>Bagaimana Cara Mendaptkan Link Google Meet ? </h3>
            Untuk mendapatkan link google meet sangatlah mudah, Berikut ini menunjukan langkah-langkah untuk mendapatkan url/link google meet
            <div class="row">
                <div class="col-md-8">
                  <ol>
                    <li>Pastikan Anda login dengan akun belajar.id atau akun Gsuite atau akun asesor</li>
                    <li>Buka alamat beriku <a href="https://meet.google.com" target="_blank">https://meet.google.com</a> </li>
                    <li>Tekan tombol "<b>New Meeting</b>" kemudian pilih "<b>Start Instant Meeting</b>"</li>
                    <li>Salin alamat google meet pada URL di browser Anda <b>lengkap sampai dengan kode nya</b>, contoh: https://meet.google.com/xxx-yyy-zzzz</li>
                    <li>Tempelkan link yang telah Anda salin di atas ke kolom yang telah disediakan di aplikasi SIMPKB</li>
                  </ol>
                </div>
                <div class="col-md-4 d-flex justify-center align-center">
                    <img src="${this.$imgUrl('google-meet.png')}" width="120" height="120"/>
                </div>
            </div>
        </div>
      `;
      this.$refs.notifikasi.open(html, 'Generate Link Gmeet');
    },
  },
  watch: {
    initValue: 'initForm',
    sessions: {
      handler: function(val) {
        const configBlokir = this.$getDeepObj(this, 'configs.blokir_slot') || {};
        val.forEach((key, index) => {
          const findBlokir = this.$getDeepObj(configBlokir, key.tgl_wawancara || '') || [];
          if (new Date(key.tgl_wawancara).getDay() === 5) {
            const findSlot = val[index]['sesi_wawancara'].findIndex((slot) =>
              [...this.blockSlots].includes(Number(slot))
            );
            if (findSlot > -1) {
              let temp = val[index]['sesi_wawancara'];
              this.$delete(temp, findSlot);
              this.$set(this['sessions'][index], 'sesi_wawancara', temp);
            }
          }

          if (findBlokir.length) {
            const findSlot = val[index]['sesi_wawancara'].findIndex((slot) => findBlokir.includes(Number(slot)));
            if (findSlot > -1) {
              let temp = val[index]['sesi_wawancara'];
              this.$delete(temp, findSlot);
              this.$set(this['sessions'][index], 'sesi_wawancara', temp);
            }
          }
        });
      },
      deep: true,
    },
    extras: {
      handler: function(val) {
        const except = [28];
        val.forEach((key, index) => {
          if (except.includes(new Date(key.tgl_wawancara).getDate())) {
            const findSlot = val[index]['sesi_wawancara'].findIndex((slot) =>
              ['0', '5', '6', '7', '8', '9'].includes(slot)
            );
            if (findSlot > -1) {
              let temp = val[index]['sesi_wawancara'];
              this.$delete(temp, findSlot);
              this.$set(this['extras'][index], 'sesi_wawancara', temp);
            }
          }
        });
      },
      deep: true,
    },
  },
};
</script>
